/* Layout */
// @ts-ignore
import Layout from '@/layout/index.vue';
import Vue from 'vue';
import Router from 'vue-router';
import Sites from '@/views/sites.vue';

Vue.use(Router);


// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/http',
    redirect: 'index'
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '/',
    component: Sites
  },
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        name: 'home',
        meta: { title: '首页', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: (resolve) => require(['@/views/system/user/profile/index'], resolve),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/dict',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'type/data/:dictId(\\d+)',
        component: (resolve) => require(['@/views/system/dict/data'], resolve),
        name: 'Data',
        meta: { title: '字典数据', icon: '' }
      }
    ]
  },
  {
    path: '/job',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'log',
        component: (resolve) => require(['@/views/monitor/job/log'], resolve),
        name: 'JobLog',
        meta: { title: '调度日志' }
      }
    ]
  },
  {
    path: '/gen',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'edit/:tableId(\\d+)',
        component: (resolve) => require(['@/views/tool/gen/editTable'], resolve),
        name: 'GenEdit',
        meta: { title: '修改生成配置' }
      }
    ]
  },
  {
    path: '/accident',
    component: Layout,
    meta: { title: '事故管理', icon: 'fa-car' },
    hidden: true,
    children: [

      {
        path: 'list',
        component: (resolve) => require(['@/views/accident/list'], resolve),
        name: 'AccidentList',
        meta: { title: '事故列表', icon: 'list' }
      },
      {
        path: 'add/:id',
        component: (resolve) => require(['@/views/accident/edit'], resolve),
        name: 'AccidentAdd',
        meta: { title: '新建事故', icon: 'add' }
      },
      {
        path: 'edit/:id',
        component: (resolve) => require(['@/views/accident/edit'], resolve),
        name: 'AccidentEdit',
        meta: { title: '事故详情', icon: 'edit' }
      },
      {
        path: 'info/:id',
        component: (resolve) => require(['@/views/accident/mediator'], resolve),
        name: 'mediatorInfo',
        meta: { title: '事故调解', icon: 'add' }
      },
    ]
  },
  {
    path: '/patient',
    component: Layout,
    meta: { title: '诊疗资料', icon: 'fa-car' },
    hidden: true,
    children: [

      {
        path: 'list',
        component: (resolve) => require(['@/views/patient/index'], resolve),
        name: 'patientIndex',
        meta: { title: '诊疗资料', icon: 'list' }
      },
  ]},
  {
    path: '/sign',
    name: 'AccidentEdit',
    component: (resolve) => require(['@/views/sign'], resolve),
    hidden: false
  }

];

export default new Router({
  mode: 'history',
  // scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
});
